var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElioLogoBubble(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59.73 59.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degrade_sans_nom_3",
    x1: 10.36,
    x2: 50.32,
    y1: 49.36,
    y2: 9.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#07dfab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47ecec"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 29.86,
    cy: 29.86,
    r: 29.86,
    fill: "url(#Degrade_sans_nom_3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.92 15.74h18.87v5.66H14.92zM20.69 27.08h13.09v5.66H20.69zM15.04 38.41h18.75v5.66H15.04zM39.16 33V15.74h5.65V33zM39.16 44.07v-5.52h5.65v5.52z",
    className: "cls-2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElioLogoBubble);
export default __webpack_public_path__ + "static/media/elio-logo-bubble.4c381c7b.svg";
export { ForwardRef as ReactComponent };